// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CompanySelectorController from "./company_selector_controller"
application.register("company-selector", CompanySelectorController)

import EmptyController from "./empty_controller"
application.register("empty", EmptyController)

import EntityPreviewController from "./entity_preview_controller"
application.register("entity-preview", EntityPreviewController)

import ExportToastController from "./export_toast_controller"
application.register("export-toast", ExportToastController)

import ExportToastsController from "./export_toasts_controller"
application.register("export-toasts", ExportToastsController)

import FileInputController from "./file_input_controller"
application.register("file-input", FileInputController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import FormsController from "./forms_controller"
application.register("forms", FormsController)

import ImageFieldController from "./image_field_controller"
application.register("image-field", ImageFieldController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import PassSearchController from "./pass_search_controller"
application.register("pass-search", PassSearchController)

import PdfViewerController from "./pdf_viewer_controller"
application.register("pdf-viewer", PdfViewerController)

import TableFilterController from "./table_filter_controller"
application.register("table-filter", TableFilterController)

import SelectableController from "./selectable_controller"
application.register("selectable", SelectableController)

import SelectionController from "./selection_controller"
application.register("selection", SelectionController)
